import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocaleModule } from 'src/app/core/locale/locale.module';
import { OnEnterDirective } from 'src/app/feature/dynamic-form/directives/on-enter.directive';
import { DateCollectionComponent } from './date-collection/date-collection.component';
import { OnAutocompleteDirective } from './directives/on-autocomplete.directive';
import { DynamicFormComponent } from './dynamic-form.component';
import { TransformDecimalDirective } from './transform/transform-decimal.directive';
import { TransformNumbersOnlyDirective } from './transform/transform-numbers-only.directive';

@NgModule({
	declarations: [
		DynamicFormComponent,
		TransformDecimalDirective,
		TransformNumbersOnlyDirective,
		DateCollectionComponent,
		OnAutocompleteDirective,
		OnEnterDirective,
	],
	exports: [DynamicFormComponent, OnAutocompleteDirective, OnEnterDirective],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, LocaleModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DynamicFormModule {}
